module.exports = __webpack_public_path__ + "static/media/empty-clarnium.114ff2f7.svg";